import { Navigate, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { Controls, ControlsButton } from '@/components/Controls';
import { PageHeading } from '@/components/Layout/Parts';
import Text from '@/components/Text';

import History from './components/History';
import Settings from './components/Settings';

const Header = styled.div`
  display: flex;
  margin: 0 0 24px;
`;

const VideoFactory = () => {
  const { page } = useParams();

  const navigate = useNavigate();

  if (!['settings', 'history'].includes(page ?? '')) {
    return <Navigate to="./settings" relative="path" replace />;
  }

  return (
    <>
      <Text $type="caption" $color="gray">
        BORED PANDA
      </Text>
      <PageHeading>Video Factory</PageHeading>
      <Header>
        <Controls>
          <ControlsButton
            active={page === 'settings'}
            onClick={() => navigate('../settings', { relative: 'path' })}
          >
            Settings
          </ControlsButton>
          <ControlsButton
            active={page === 'history'}
            onClick={() => navigate('../history', { relative: 'path' })}
          >
            History
          </ControlsButton>
        </Controls>
      </Header>
      {page === 'settings' && <Settings />}
      {page === 'history' && <History />}
    </>
  );
};

export default VideoFactory;
